module.exports = __webpack_public_path__ + "img/gaojing.0cb39207.png";